module.exports = __webpack_public_path__ + "img/buildres.bb6898d2.avif";